import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login/:companyKey',
        name: 'Login',
        component: () => import('@/views/LoginPage.vue'),
        meta: {
            title: 'Welcome to EinsteinFI'
        },
        props: true
    },
    {
        path: '/admin-proxy',
        name: 'Admin Proxy',
        component: () => import('@/views/AdminRedirect'),
        meta: {
            title: 'Admin Proxy'
        }
    },
    {
        path: '/income-planner',
        name: 'IncomePlanner',
        component: () => import('@/views/IncomePlanner'),
        meta: {
            pageSwitchKey: 'my_plan_page',
            title: 'See My Plan',
            auth: true
        }
    },
    {
        path: '/create-income-planner',
        name: 'CreateIncomePlanner',
        component: () => import('@/views/CreateMyPlan'),
        meta: {
            title: 'Create My Plan',
            auth: true
        }
    },
    {
        path: '/accounts',
        name: 'Accounts',
        component: () => import('@/views/Accounts'),
        meta: {
            pageSwitchKey: 'accounts_page',
            title: 'Accounts',
            auth: true
        }
    },
    {
        path: '/net-worth-summary',
        name: 'NetWorth',
        component: () => import('@/views/NetWorth'),
        meta: {
            pageSwitchKey: 'networth_page',
            title: 'Net Worth Summary',
            auth: true
        }
    },
    {
        path: '/positions',
        name: 'Positions',
        component: () => import('@/views/Positions'),
        meta: {
            pageSwitchKey: 'positions_page',
            title: 'Positions',
            auth: true
        }
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard'),
        meta: {
            pageSwitchKey: 'dashboard_page',
            title: 'Dashboard',
            auth: true
        }
    },
    {
        path: '/year-to-date-performance',
        name: 'YearToDatePerformance',
        component: () => import('@/views/YearToDatePerformance'),
        meta: {
            pageSwitchKey: 'performance_page',
            title: 'Year To Date Performance',
            auth: true
        }
    },
    {
        path: '/vault',
        name: 'Vault',
        component: () => import('@/views/Vault'),
        meta: {
            title: 'Vault',
            auth: true
        }
    },
    {
        path: '/adjust-your-plan',
        name: 'AdjustYourPlan',
        component: () => import('@/views/AdjustYourPlan'),
        meta: {
            title: 'Adjust Your Plan',
            auth: true
        }
    },
    {
        path: '/investment-options',
        name: 'InvestmentOptions',
        component: () => import('@/views/InvestmentOptions'),
        meta: {
            title: 'Investment Options',
            auth: true
        }
    },
    {
        path: '/reports',
        name: 'Reports',
        component: () => import('@/views/Reports'),
        meta: {
            title: 'Reports',
            auth: true
        }
    },
    {
        path: '/settings',
        name: 'Settings',
        component: () => import('@/views/Settings'),
        meta: {
            title: 'Settings',
            auth: true
        }
    },
    {
        path: '/get-started',
        name: 'GetStarted',
        component: () => import('@/views/questionnaire/GetStarted.vue'),
        meta: {
            title: 'Welcome to EinsteinFI',
            auth: true
        }
    },
    {
        path: '/questionnaire/working-retired',
        name: 'PersonOneWorkingRetired',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/PersonOneWorkingRetired.vue')
    },
    {
        path: '/questionnaire/married-single',
        name: 'MarriedSingle',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/MarriedSingle.vue')
    },
    {
        path: '/questionnaire/name',
        name: 'Name',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/IndividualName.vue')
    },
    {
        path: '/questionnaire/spouse-working-retired',
        name: 'SpouseWorkingRetired',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/PersonTwoWorkingRetired.vue')
    },
    {
        path: '/questionnaire/expect-retirement',
        name: 'ExpectRetirement',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/ExpectRetirement.vue')
    },
    {
        path: '/questionnaire/age',
        name: 'IndividualAge',
        component: () => import('@/views/questionnaire/IndividualAge.vue')
    },
    {
        path: '/questionnaire/section-2',
        name: 'SectionTwo',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/SectionTwo.vue')
    },
    {
        path: '/questionnaire/goals',
        name: 'Goals',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/Goals.vue')
    },
    {
        path: '/questionnaire/income-needs',
        name: 'IncomeNeeds',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/IncomeNeeds.vue')
    },
    {
        path: '/questionnaire/pensions',
        name: 'HavePensions',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/HavePensions.vue')
    },
    {
        path: '/questionnaire/pension',
        name: 'Pension',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/Pensions.vue'), props: true
    },
    {
        path: '/questionnaire/have-income',
        name: 'HaveIncome',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/HaveIncome.vue')
    },
    {
        path: '/questionnaire/income',
        name: 'Income',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/Incomes.vue')
    },
    {
        path: '/questionnaire/additional-income',
        name: 'AdditionalIncome',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/AdditionalIncome.vue')
    },
    {
        path: '/questionnaire/have-savings',
        name: 'HaveSavings',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/HaveSavings.vue')
    },
    {
        path: '/questionnaire/savings',
        name: 'Savings',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/Savings.vue')
    },
    {
        path: '/questionnaire/section-3',
        name: 'SectionThree',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/SectionThree.vue')
    },
    {
        path: '/questionnaire/accounts',
        name: 'QuestionnaireAccounts',
        meta: {
            auth: true
        },
        component: () => import('@/views/questionnaire/Accounts.vue')
    },
    {
        path: '/questionnaire/thank-you',
        name: 'ThankYou',
        component: () => import('@/views/questionnaire/ThankYou.vue'),
        meta: {
            title: 'Thank you',
            auth: true
        }
    },
    {
        path: '/portfolios',
        name: 'Portfolios',
        component: () => import('@/views/PortfoliosPage'),
        meta: {
            title: 'Portfolios',
            auth: true
        },
        beforeEnter: (to, from, next) => {
            if (store.state.auth.portfolios) {
                next();
            } else {
                next('/dashboard');
            }
        }
    },
    {
        path: '/newsletters',
        name: 'Newsletters',
        component: () => import('@/views/Newsletters'),
        meta: {
            pageSwitchKey: 'newsletters_page',
            title: 'Newsletters',
            auth: true
        }
    },
    {
        path: '*',
        name: 'catchAll',
        component: () => import('@/views/LandingPage.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const loggedIn = store.getters["auth/isLogged"];

    if (to.matched.some(record => record.meta.auth) && !loggedIn) {
        next('/')
        return
    }

    if (!store.getters['auth/isPageActive'](to.meta.pageSwitchKey)) {
        next({name: store.getters['auth/defaultPageName']});
        return
    }

    if (to.name === 'Portfolios' && !store.getters['company/isMainCompany']) {
        next({name: store.getters['auth/defaultPageName']});
        return
    }

    store.dispatch('loader/reset');

    next()
})

export default router
